import React, { useState, useEffect } from 'react';
import { Checkbox, Skeleton } from '@mui/material';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../config/firebase';

const ViewOrderTransaction = ({ orderRef }) => {
  const [orderTransaction, setOrderTransaction] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTransactions = async () => {
      const q = query(collection(db, 'transactions'), where('orderRef', '==', orderRef));
      const transactionsSnapshot = await getDocs(q);
      setOrderTransaction(transactionsSnapshot.docs.length > 0);
      setLoading(false);
    };
    if (orderRef) fetchTransactions().then();
  }, [orderRef]);
  // const dispatch = useDispatchProvider();
  // // const supplierDocRef = doc(db, 'suppliers', supplierId);
  // // const supplierDocRef = getDoc(supplierRef);
  // // const [supplierData, loading] = useDocumentData(supplierRef ?? null);
  // useEffect(() => {
  //   // console.log(orderRef);
  //   const fetchOrder = async () => {
  //     const orderSnap = await getDoc(orderRef);
  //     // console.log(orderSnap.data());
  //     if (orderSnap.exists()) {
  //       setOrderData({ id: orderSnap.id, ...orderSnap.data() });
  //     }
  //   };
  //   if (orderRef.id) {
  //     fetchOrder().then();
  //   }
  // }, [orderRef]);
  // const handleClickOrder = (e) => {
  //   e.stopPropagation();
  //   e.preventDefault();
  //   dispatch && dispatch({ type: Actions.FormOrder, payload: orderData.id });
  //   dispatch && dispatch({ type: Actions.TabsOrder, payload: 'products' });
  //   dispatch && dispatch({ type: Actions.DrawerOrder, payload: true });
  // };

  if (loading)
    return (
      <>
        <Skeleton
          variant={'rectangular'}
          height={24}
          width={24}
          animation={'wave'}
        />
      </>
    );
  return (
    <Checkbox
      checked={orderTransaction}
      disabled={true}
    />
  );
};

export default ViewOrderTransaction;
